import { useGetIsFlexUserQuery } from '../../services/entitlementsApi';

/**
 * Component that loads the boolean whether the user is a Flex user or not.
 * This component doesn't render anything, it just fetches the data.
 */
export const IsFlexUserLoader = () => {
  useGetIsFlexUserQuery(undefined);

  return null;
};

export default IsFlexUserLoader;
